import type { IGlobalTab, TabGroup } from '@carboncopyco/types/desktop';
import { useTabs } from '../store/context';

const useEditorGroupTab = () => {
  const { globalTabsRef, setGlobalTabs } = useTabs();

  const getFirstGroupTabByGroupId = (groupId: TabGroup['id']) => {
    return globalTabsRef.current.find(
      (tab) => tab.group && tab.group?.id === groupId
    );
  };

  const updateEditorTabVisibility = ({
    editorTab,
    show,
  }: {
    editorTab: IGlobalTab;
    show: boolean;
  }) => {
    const updatedTabs = globalTabsRef.current.map((tab) => {
      const isEditorTab = tab.id === editorTab.id;

      return isEditorTab && !!tab.group
        ? {
            ...tab,
            hidden: !show,
            group: {
              ...tab.group,
              isVisibleIfGroupIsInactive: show,
              isVisibleIfGroupIsActive: show,
            },
          }
        : tab;
    });

    setGlobalTabs(updatedTabs);
  };

  return {
    updateEditorTabVisibility,
    getFirstGroupTabByGroupId,
  };
};

export default useEditorGroupTab;
